// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"select_wrapper__2IPLR","label":"select_label__vGfjb","select":"select_select__2pfF-"};